<template>
  <v-card outlined :color="color" class="py-0">
    <v-card-title class="subtitle-2 pt-2">
      <template>
        <span>{{ coverage.name }}</span>
        <v-spacer />
        <v-icon v-if="location" class="blue3--text">mdi-map</v-icon>
        <v-icon v-if="building" class="blue3--text">mdi-office-building</v-icon>
      </template>
    </v-card-title>
    <v-card-subtitle v-if="location || building">
      <template v-if="location">
        <span>Location {{ location.number }}</span>
        <span v-if="(location.name || null) !== null && location.name.trim() !== ''"> - {{ location.name }}</span>
      </template>
      <template v-if="building">
        <span>Building {{ building.number }}</span>
        <span v-if="(building.name || null) !== null && building.name.trim() !== ''"> - {{ building.name }}</span>
      </template>
    </v-card-subtitle>
    <v-card-text class="pb-2">
      <v-row wrap>
        <v-col class="py-0" cols="6">
          <DisplayField label="Limit" :value="coverage.limits" />
        </v-col>
        <v-col class="py-0" cols="6">
          <DisplayField label="Deductible" :value="coverage.deductibles" />
        </v-col>
        <v-col class="pt-1 pb-0" cols="6">
          <DisplayField label="Premium" :value="coverage.premium" type="currency" />
        </v-col>
        <v-col v-if="hasOptions" class="pt-1 pb-0" cols="12">
          <div class="label">Notes</div>
          <div v-for="(option, oIdx) in options" :key="oIdx" class="caption">
            {{ option.description }}
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style scoped>
</style>

<script>
import DisplayField from '@/components/Shared/DisplayField.vue';

export default {
  name: 'CoverageCard',
  components: { DisplayField },
  props: {
    coverage: {
      type: Object,
      default: null
    },
    location: {
      type: Object,
      default: null
    },
    building: {
      type: Object,
      default: null
    },
    color: {
      default: 'grey6',
      type: String
    }
  },
  computed: {
    hasOptions () {
      if ((this.options || null) === null || this.options.length === 0) return false;

      return true;
    },
    options () {
      if (this.coverage === null || this.coverage.options === null || this.coverage.options.length === 0) {
        return null;
      }

      return this.coverage.options.filter(x => x.description !== null && x.description !== '');
    }
  }
};
</script>
